<template>
  <roe-error-message :field="design.auto_increase_type">
    <roe-radio-input
      v-model="design.$model.auto_increase_type"
      label1="Pre-Tax"
      label2="Roth"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import { AutoIncreaseMixin } from "@/components/_shared/inputs/design/_mixins";
export default {
  name: "RoeAutoIncreaseTypeRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  mixins: [AutoIncreaseMixin],
  props: {
    design: Object
  }
};
</script>
